var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-10 mx-auto"},[_c('form-summary-grid',{attrs:{"formToRegisterEntityId":_vm.id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }